export class HospitalTeamMemberModel {
  id?: number;
  email?: string;
  firstName?: string;
  lastName?: string;
  password?: string;
  isNotificationEnabled?: boolean;
  isDeleted?: boolean = false;
  isActive?: boolean = true;
  totalRecords?: number;
}